import { render, staticRenderFns } from "./specialCourses.vue?vue&type=template&id=2d6bd912&scoped=true&"
import script from "./specialCourses.vue?vue&type=script&lang=js&"
export * from "./specialCourses.vue?vue&type=script&lang=js&"
import style0 from "./specialCourses.vue?vue&type=style&index=0&id=2d6bd912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6bd912",
  null
  
)

export default component.exports